export const MAP_OPTIONS = {
	MAX_ZOOM: 22,
	MIN_ZOOM: 7,
	LIST_WIDTH: 288,
	DEFAULT_ZOOM: 12,
	DEFAULT_CENTER: { lat: 47.5013803, lng: 19.0490411 }
};

export const TIME_RESERVATION_TYPES = {
	RESIDENTIAL: 'RESIDENTIAL',
	COMPANY: 'COMPANY',
	PARTNER: 'PARTNER'
};

export const TIME_RESERVATION_TA_TYPES = {
	RESIDENTIAL: 'Lakossági',
	COMPANY: 'Vállalkozói'
};

export const TYPE_TA = 'UGYF_TIPUS';

export const DEFAULT_ADDRESS = 'Budapest, Nádor u. 16, 1051 Magyarország';
